import { render } from "./imageTextCarousel.vue?vue&type=template&id=1b73fc83&scoped=true"
import script from "./imageTextCarousel.vue?vue&type=script&lang=js"
export * from "./imageTextCarousel.vue?vue&type=script&lang=js"

import "./imageTextCarousel.vue?vue&type=style&index=0&id=1b73fc83&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\storyworld-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b73fc83"]])

export default __exports__